import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef,  ViewChild, ViewEncapsulation } from '@angular/core';
import { SetPropertySubcategoryLabelDirective } from 'src/app/directives/set-property-subcategory-label.directive';
import { FormService } from '../../shared/form.service';
import { SharedService } from '../../shared/shared.service';
import { TrackService } from 'src/app/services/track.service';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { MapTrackingService } from 'src/app/services/mapTracking.service';
import { OfferService } from 'src/app/shared/offer.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy {
  parentForm;
  icons = {
    1: 'product-house-broken-window',
    2: 'product-couch',
    3: 'product-house'
  };

  constructor(public sharedService: SharedService,
    private formService: FormService,
    public mapTrackService: MapTrackingService,
    public offerService : OfferService,
    private trackService: TrackService, public dialogService: NxDialogService,) {
  }

  ngOnInit() {
    this.parentForm = this.formService.currentForm;
    this.trackService.addStepsInfo('category', 'Quote & Buy',true);
    this.trackService.addStepsInfo('processName', 'Quote & Buy - Property', true);
    this.offerService.savedOfferId = null; 
  }

  ngOnDestroy(): void {
    this.setCurrencyData()
  }

  setCurrencyData(){
    this.sharedService.currency$.subscribe(
     (data : any) => {
      this.parentForm.controls?.currency.setValue(data.main);
      this.parentForm.controls?.doubleVisualization.setValue(data.doubleVisualisation)

     });
}
  propTypeClick(propType) {
    let typeNames = ['buildingAndContent', 'content', 'building'];
  }

  @ViewChild('template') templateRef!: TemplateRef<any>;
  templateDialogRef: any;

  openPopUp(){
    this.templateDialogRef = this.dialogService.open(this.templateRef, {ariaLabel: 'A simple dialog', showCloseIcon: true} );
  } 

  
}
